export default { currencies: { gbp: '£', eur: '€' } }
